import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface CategoryCount {
  category: string;
  count: number;
}

interface PersonsPageData {
  persons: any[];
  contacts: any[];
  emergency_contacts: any[];
  categories: CategoryCount[];
}

/**
 * Hook optimisé qui charge toutes les données de la page personnes en une seule requête RPC
 */
export function usePersonsPageData(familyId?: string) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['persons-page-data', familyId],
    queryFn: async (): Promise<PersonsPageData> => {
      if (!familyId) {
        return { persons: [], contacts: [], emergency_contacts: [], categories: [] };
      }

      const { data, error } = await supabase.rpc('get_persons_data', {
        p_family_id: familyId
      });

      if (error) {
        console.error('Error fetching persons data:', error);
        throw error;
      }

      const result = (data as unknown) as PersonsPageData;

      // Pré-remplir les caches individuels
      if (result.persons) {
        queryClient.setQueryData(['optimized-person-profiles', familyId], result.persons);
      }

      return result;
    },
    enabled: !!familyId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
}
